import React from 'react';
import { useNavigate } from 'react-router-dom';
import BaseModal from '../../utils/BaseModal';
import { ItemDTO } from '../../user/on-sale/types';
import ItemAnalytics from './analytics/ItemAnalytics';
import BuyOrderList from './buy-order/BuyOrderList';
import ItemDetails from './item/ItemDetails';

type Props = {
  open: boolean;
  onClose: () => void;
  item: ItemDTO | null;
};

const ItemDetailLightModal: React.FC<Props> = ({ open, onClose, item }) => {
  const navigate = useNavigate();

  if (!item) return null;

  const searchName = item.catalog?.groupName || item.catalog?.marketHashName || '';
  const referencePriceMinor =
      item.catalog?.priceReal24hMinor ??
      (item.catalog as any)?.priceRealMinor ??
      undefined;

  const handleShowSimilar = () => {
    onClose();
    if (searchName) {
      navigate(`/market?search=${encodeURIComponent(searchName)}`);
    } else {
      navigate('/market');
    }
  };

  return (
      <BaseModal open={open} onAbort={onClose} maxWidth="lg">
        <div className="flex flex-col gap-6 p-1">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
            {/* LEFT: Buy Orders (5/12) */}
            <div className="lg:col-span-5 order-2 lg:order-1 max-h-[400px] lg:h-[400px]">
              <BuyOrderList
                  marketHashName={item.catalog?.marketHashName ?? undefined}
                  referencePriceMinor={referencePriceMinor}
              />
            </div>

            {/* RIGHT: Item Image, Rarity & "Show Similar Items" Button (7/12) */}
            <div className="lg:col-span-7 order-1 lg:order-2">
              <ItemDetails
                  item={item}
                  showSimilarButton={true}
                  onShowSimilar={handleShowSimilar}
              />
            </div>
          </div>

          {/* BOTTOM: Pricing Charts & Analytics */}
          <div className="order-3">
            <ItemAnalytics
                itemAssetId={item.itemAssetId || item.catalog?.marketHashName || ''}
                wearName={item.catalog?.wearName ?? undefined}
            />
          </div>
        </div>
      </BaseModal>
  );
};

export default ItemDetailLightModal;
